import { Dialog, DialogProps } from "@mui/material";
import clsx from "clsx";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import classes from "./styles.module.scss";
import { IconButton } from "../IconButton/IconButton";
import { centederViewOnContent } from "../../utils/centerViewOnContent";

interface Props extends DialogProps {
  size?: "sm" | "md" | "lg";
  adaptive?: boolean;
  onAfterClose?: () => void;
}

export const Modal = ({
  children,
  size = "md",
  className,
  adaptive = false,
  onAfterClose,
  ...props
}: Props) => {
  const handleCloseClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    props.onClose?.(e, "escapeKeyDown");
  };

  return (
    <Dialog
      className={clsx(classes.modal, className, {
        [classes[size]]: true,
        [classes.adaptive]: adaptive,
      })}
      disableScrollLock
      PaperProps={{
        id: "modal-centered",
      }}
      onTransitionEnter={() => centederViewOnContent("#modal-centered")}
      onTransitionExited={onAfterClose}
      {...props}
    >
      {children}
      <IconButton className={classes.closeIcon} onClick={handleCloseClick}>
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
};
